import { Toaster as Sonner } from "sonner";
import {
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  Loader2,
} from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      gap={8}
      className="toaster group xale-toaster"
      toastOptions={{
        classNames: {
          toast: `
            group toast
            border border-[color-mix(in_srgb,var(--color-green-9)_12%,var(--color-black-8))]
            rounded-2xl backdrop-blur-xl
            pr-12
          `,
          title: "font-medium text-[var(--color-black-1)]",
          content: "gap-0.5",
          description: "text-sm",

          closeButton: `
            !border-[color-mix(in_srgb,var(--color-white)_12%,var(--color-black-6))]
            !bg-[linear-gradient(168deg,var(--color-black-5)_0%,var(--color-black-7)_45%,var(--color-black-9)_100%)]
            !text-[var(--color-black-2)]
            !shadow-[inset_0_1px_0_rgba(255,255,255,0.22),0_4px_12px_rgba(30,48,42,0.35)]
            hover:!brightness-105 hover:!border-[color-mix(in_srgb,var(--color-green-7)_28%,var(--color-black-5))]
          `,

          actionButton:
            "bg-[var(--color-primary)] text-[var(--color-white)] shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] hover:opacity-90",

          cancelButton:
            "bg-[var(--color-black-8)] text-[var(--color-black-2)] hover:text-[var(--color-white)]",

          success: "text-[var(--color-green-9)]",
          error: "text-[var(--color-high)]",
          warning: "text-[var(--color-medium)]",
          info: "text-[var(--color-cold)]",
        },
      }}
      icons={{
        success: (
          <CheckCircle2 className="size-5 text-[var(--color-green-9)]" />
        ),
        info: <Info className="size-5 text-[var(--color-cold)]" />,
        warning: (
          <AlertTriangle className="size-5 text-[var(--color-medium)]" />
        ),
        error: <XCircle className="size-5 text-[var(--color-high)]" />,
        loading: (
          <Loader2 className="size-5 animate-spin text-[var(--color-black-4)]" />
        ),
      }}
      {...props}
      position="bottom-center"
    />
  );
};

export { Toaster };
